import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type BookOrder as SchemaBookOrder } from '../schemas/BookOrder';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const BookOrderContentType = '' as const;
export type BookOrderRequest = void;
export type BookOrderResponses = LinkCommonErrorResponses & {
    /**
     * @description Order booked
     */
    '200': {
        'application/json': SchemaBookOrder;
    };
};
export type BookOrderResponseSuccess = BookOrderResponses['200']['application/json'];
export type BookOrderSearchParams = {
    signature: string;
};
export type BookOrderPathParameters = {
    store_slug: string;
    order_id: string;
};
export const BookOrderUrl = '/{store_slug}/orders/{order_id}/book' as const;
export const BookOrderMethod = 'POST' as const;
export const getBookOrderUrl = (params: BookOrderPathParameters) =>
    BookOrderUrl.replace(/\{(\w+)\}/g, (_match, param: keyof BookOrderPathParameters) => String(params[param]));
